/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonButton, IonItem, IonToast, useIonModal } from '@ionic/react';
import { EmptyUserLedger, User, UserLedger } from 'model';
import { useState } from 'react';
import { Confirmation } from '../../pages/Confirmation';
// styles
// eslint-disable-next-line css-modules/no-unused-class
import settingsMenuStyles from '../SettingsMenu.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import classNames from 'classnames';
import {
	useCreateLedgerMutation,
	useGetAdminLedgerBalanceQuery,
	useGetAdminLedgerQuery
} from '../../api/UserLedgerAPI.js';
import { AddTokenModal } from '../../pages/admin/AddTokenModal.js';
import { IconQuirktoken } from '../QuirkIcons/index.js';
import styles from './AdminUserMenuPayments.module.css';

export const AdminUserMenuPayments: React.FC<{
	user: User;
}> = ({ user }) => {
	const userid = user._id;
	const { data: userTransactions } = useGetAdminLedgerQuery(userid);
	const { data: { response: userBalance } = { response: 0 } } = useGetAdminLedgerBalanceQuery(userid);
	const [createLedger, { isSuccess, isError: isLedgerError }] = useCreateLedgerMutation();
	const [addTokenAmountSubmit, setAddTokenAmountSubmit] = useState<number>();

	const addTokenAmount = () => {
		dismissAddToken();
		if (user && addTokenAmountSubmit) {
			const ledger: UserLedger = {
				...EmptyUserLedger,
				user: user?._id,
				amount: addTokenAmountSubmit,
				transactionStatus: 'completed'
			};
			createLedger({ ledger });
		}
	};

	const [presentAddToken, dismissAddToken] = useIonModal(Confirmation, {
		onDismiss: () => dismissAddToken(),
		action: addTokenAmount,
		actionLabel: 'Add Tokens',
		dismissLabel: 'Cancel',
		content: <AddTokenModal user={user} setAddTokenAmountSubmit={setAddTokenAmountSubmit} />
	});

	return (
		<>
			<>
				{user && (
					<>
						<hr className="hr" />
						<div className={classNames(settingsMenuStyles.menuItemContainer, styles.smallTitle)}>
							Payments
						</div>
						<IonItem className={settingsMenuStyles.ionItem}>
							<div className={styles.jewelItem}>
								<div className={settingsMenuStyles.menuItemLabel}>Account Balance</div>
								<div className={styles.jewelGreen}>
									<div className="quirkToken">
										<IconQuirktoken />
									</div>
									{userBalance?.toLocaleString()}
								</div>
							</div>
						</IonItem>
						<IonItem className={settingsMenuStyles.ionItem} lines="none">
							<div className={styles.jewelItem}>
								<div className={settingsMenuStyles.menuItemLabel}>Total Transactions</div>
								<div className={styles.jewelGray}>{userTransactions && userTransactions.length}</div>
							</div>
						</IonItem>
						<div className={styles.fixedfieldContainer}>
							<div className="space20" />
							<IonButton
								color="primary"
								fill="outline"
								size="default"
								className="radius8"
								expand="block"
								onClick={() => presentAddToken()}
							>
								Add Tokens
							</IonButton>
						</div>
						<div className="space20" />
						<hr className="hr" />
					</>
				)}
			</>
			<IonToast isOpen={isSuccess} duration={1500} message="Tokens were added" position="top" color="success" />
			<IonToast
				isOpen={isLedgerError}
				duration={1500}
				message="Error adding tokens"
				position="top"
				color="danger"
			/>
		</>
	);
};
